<template>
  <div class="range-wrapper">
    <label v-if="!!label">{{ label }}</label>
    <div class="range">
      <ps-date-field
        :value="value && value.from"
        @input="$emit('input', { from: $event, to: value.to })"
        @change="$emit('change', { from: $event, to: value.to })"
      />
      <span>-</span>
      <ps-date-field
        :value="value && value.to"
        @input="$emit('input', { from: value.from, to: $event })"
        @change="$emit('change', { from: value.from, to: $event })"
      />
    </div>
  </div>
</template>

<script>
import DateField from './DateField';
export default {
  components: {
    'ps-date-field': DateField
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => ({ from: '', to: '' })
    }
  }
};
</script>

<style lang="scss" scoped>
.range-wrapper {
  display: grid;
  grid-template-rows: max-content max-content;
  grid-gap: 5px;
  .range {
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
    grid-gap: 10px;
    align-items: center;

    > * {
      min-width: 0;
      min-height: 0;
    }
  }
  label {
    font-weight: 500;
    font-size: 0.75rem;
    letter-spacing: 0.025em;
  }
}
</style>
